// extracted by mini-css-extract-plugin
module.exports = {"error":"StatusMessage__error___LOn9K","success":"StatusMessage__success___1Jhnl"};